import { Component, Input } from '@angular/core';
import { environment } from '@fb-tool-front/environments/environment';

@Component({
  selector: 'app-youtube-embedded',
  templateUrl: './youtube-embedded.component.html',
  styleUrls: ['./youtube-embedded.component.scss']
})
export class YoutubeEmbeddedComponent {
  @Input()
  youtubeTutorVideo = environment.youtubeTutorVideoEn;

  @Input()
  width = '560';

  @Input()
  height = '315';
}
